import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Chip,
  Divider,
  IconButton,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import {
  CheckCircleOutline as CheckCircleOutlineIcon,
  HourglassEmpty as HourglassEmptyIcon,
  Event as EventIcon,
  MoreVert as MoreVertIcon,
} from '@mui/icons-material';
import moment from 'moment';
import baseUrl from '../config';

const StatusChip = ({ status }) => {
  const statusStyles = {
    completed: { backgroundColor: '#e6f4ea', color: '#388e3c' },
    pending: { backgroundColor: '#fff3e0', color: '#e65100' },
    absent: { backgroundColor: '#ffebee', color: '#b71c1c' },
  };

  return (
    <Chip
      label={status.charAt(0).toUpperCase() + status.slice(1)}
      sx={{
        ...statusStyles[status],
        fontWeight: '600',
        borderRadius: '16px',
        px: 2,
        fontSize: '0.9rem',
      }}
    />
  );
};

const StudentAttendanceHistory = () => {
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedAttendance, setSelectedAttendance] = useState(null);
console.log(attendanceData,"attendanceData")
  useEffect(() => {
    const fetchAttendanceData = async () => {
      try {
        const response = await fetch(`${baseUrl}api/students/performance`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch attendance data. Status: ${response.status}`);
        }

        const data = await response.json();
        setAttendanceData(data.attendance || []);
      } catch (err) {
        setError(err.message || 'An unexpected error occurred.');
      } finally {
        setLoading(false);
      }
    };

    fetchAttendanceData();
  }, []);

  const handleAttendanceClick = (attendance) => {
    setSelectedAttendance(attendance);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedAttendance(null);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', padding: 3 }}>
        <Typography variant="h6" color="error">{error}</Typography>
        <Button variant="contained" onClick={() => window.location.reload()}>Retry</Button>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>Attendance History</Typography>
      <List>
        {attendanceData.map((attendance) => (
          <React.Fragment key={attendance._id}>
            <ListItem button onClick={() => handleAttendanceClick(attendance)}>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: attendance.status === 'completed' ? '#e6f4ea' : attendance.status === 'pending' ? '#fff3e0' : '#ffebee' }}>
                  {attendance.status === 'completed' ? <CheckCircleOutlineIcon /> : attendance.status === 'pending' ? <HourglassEmptyIcon /> : <EventIcon />}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={moment(attendance.classSchedule.classDate).format('MMMM D, YYYY')}
                secondary={`${attendance.classSchedule.dayOfWeek} - ${attendance.classSchedule.time}`}
              />
              <StatusChip status={attendance.status} />
              <IconButton edge="end">
                <MoreVertIcon />
              </IconButton>
            </ListItem>
            <Divider />
          </React.Fragment>
        ))}
      </List>

      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        {selectedAttendance && (
          <>
            <DialogTitle>Attendance Details</DialogTitle>
            <DialogContent>
              <Typography variant="body1">
                <strong>Date:</strong> {moment(selectedAttendance.classSchedule.classDate).format('MMMM D, YYYY')}
              </Typography>
              <Typography variant="body1">
                <strong>Day:</strong> {selectedAttendance.classSchedule.dayOfWeek}
              </Typography>
              <Typography variant="body1">
                <strong>Time:</strong> {selectedAttendance.classSchedule.time}
              </Typography>
              <Typography variant="body1">
                <strong>Status:</strong> {selectedAttendance.status}
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog}>Close</Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default StudentAttendanceHistory;
